import { axios } from "lib/axios";
import { useQuery } from "react-query";

export const getTendersDetails = () => {
  return axios.get(`/pages/slug/tenders-&-bids`);
};

export const useTendersDetails = ({ config } = {}) => {
  return useQuery({
    ...config,
    queryKey: ["tendersDetails"],
    queryFn: () => getTendersDetails(),
  });
};
